export default __webpack_public_path__ + "static/media/mask6.0827b9b8.jpeg";